module.exports = __webpack_public_path__ + "media/幸福里的思念.e236a50d.mp3";